import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function dateEndMustBeAfterDateStart(dateStartControlName: string, dateEndControlName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const dateStart = control.get(dateStartControlName);
    const dateEnd = control.get(dateEndControlName);

    if (dateStart && dateEnd) {
      if (dateStart.value && dateEnd.value) {
        if ((dateStart.value as Date).getTime() >= (dateEnd.value as Date).getTime()) {
          return {
            description: 'Debe ingresar una fecha posterior a la fecha de inicio. Por favor intenta con otra.',
            code: '300',
          };
        }
      }
    }
    return null;
  };
}
